import React from 'react';
export var Close = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { width: "23", height: "23", viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M17.1354 5.86588L5.8659 17.1354", stroke: color, strokeWidth: "1.3", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M5.86458 5.86588L17.1341 17.1354", stroke: color, strokeWidth: "1.3", strokeLinecap: "round", strokeLinejoin: "round" })));
};
